import axios from 'axios';
import { loadingActions } from '../redux/actions';
import { HEXtoBlackOrWhite } from './colors';
import { Store } from '../redux/stores';

export const getMessagesFriendList = async () => {
    Store.dispatch(loadingActions.loadingStart('messages.getMessages'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/messages/');

        if (resp && resp.data && resp.data.payload) {
            for (let i in resp.data.payload) {  
                resp.data.payload[i].fgColor = HEXtoBlackOrWhite(resp.data.payload[i].color ?? '#000000') ?? "#fff";
            }
        }
        
        Store.dispatch(loadingActions.loadingEnd('messages.getMessages'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('messages.getMessages'));
        return e.response.data;
    }
};

export const saveMessage = async (from, to, message) => {
    Store.dispatch(loadingActions.loadingStart('messages.saveMessage'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/messages/', {
            from, 
            to, 
            message
        });
        
        Store.dispatch(loadingActions.loadingEnd('messages.saveMessage'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('messages.saveMessage'));
        return e.response.data;
    }
};

export const getMessagesFromFriend = async (userId) => {
    Store.dispatch(loadingActions.loadingStart('messages.getMessagesFromFriend'));
    try {
        let resp = await axios.get(process.env.REACT_APP_HOST + '/messages/'+userId);
        
        Store.dispatch(loadingActions.loadingEnd('messages.getMessagesFromFriend'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('messages.getMessagesFromFriend'));
        return e.response.data;
    }
};

export const acceptJoinFromMessage = async (messageId) => {
    Store.dispatch(loadingActions.loadingStart('messages.acceptJoinFromMessage'));
    try {
        let resp = await axios.post(process.env.REACT_APP_HOST + '/messages/accept-join/' + messageId);
        
        Store.dispatch(loadingActions.loadingEnd('messages.acceptJoinFromMessage'));

        return resp.data;
    } catch (e) {
        Store.dispatch(loadingActions.loadingEnd('messages.acceptJoinFromMessage'));
        return e.response.data;
    }
};
